<template>
  <div class="lcu-shimmer-line" :style="{ height, width }" />
</template>

<script>
export default {
  name: 'shimmer-line',
  props: {
    width: {
      type: String,
      required: false,
    },
    height: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-shimmer-line {
  animation : shimmer 1.5s infinite linear;
  background: linear-gradient(to right, #bebebe 5%, #e9e9e9 25%, #c2c2c2 36%);
  background-size: 1000px 100%;
  border-radius: 8px;
  height: 10px;
  opacity: .5;
  width: 100%;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}
</style>
